<template>
  <v-dialog v-model="visible" width="450">
    <v-card class="cardStyle">
      <v-card-title class="headline lighten-2 titleCard" primary-title>
        <span>
          {{ title }}
        </span>
        <v-icon style="position: absolute; right: 15px" large @click="reject">
          mdi-close
        </v-icon>
      </v-card-title>

      <v-card-text v-html="message" />
      <v-card-actions style="margin-top: 20px">
        <v-col>
          <v-row justify="center">
            <v-btn v-if="!oneButton" x-large class="btnNo" dark @click="reject">
              {{ noText }}
            </v-btn>
            <v-btn v-if="oneButton" x-large class="btnYes" @click="accept">
              {{ $t('Login') }}
            </v-btn>
            <v-btn v-if="!oneButton" x-large class="btnYes" @click="accept">
              {{ yesText }}
            </v-btn>
            <v-btn v-if="oneButton" x-large class="btnNo" color="#636363" dark @click="reject">
              {{ $t('Cancel') }}
            </v-btn>
          </v-row>
        </v-col>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
    name: "ConfirmationModal",
    components: {
    },
    data: () => ({
        visible: false,
        title: "Title",
        message: "Message",
        yesText: 'Yes',
        noText: 'No',
        oneButton: false,
        onYes: null,
        onNo: null,
    }),
    created () {
        this.$root.$on('show-confirmation-modal', (event) => {
            this.handleCallbacks(event);
            this.setInformation(event);
            this.show(event);
        });
    },
    methods: {
        show () {
            this.visible = true;
        },
        hide () {
            this.visible = false;
        },
        accept () {
            if (this.$data.onYes) {
                this.$data.onYes();
            }
            this.hide();
        },
        reject () {
            if (this.$data.onNo) {
                this.$data.onNo();
            }
            this.hide();
        },
        setInformation (jInfo) {
            this.title = jInfo.title;
            this.message = jInfo.message;
            this.oneButton = jInfo.oneButton;
            if (jInfo.yesText) {
                this.yesText = jInfo.yesText;
            } else {
                this.yesText = this.$t('ConfirmationModal.Yes');
            }
            if (jInfo.noText) {
                this.noText = jInfo.noText;
            } else {
                this.noText = this.$t('No');
            }
        },
        handleCallbacks (event) {
            if (typeof event.yes === 'function') {
                this.$data.onYes = event.yes;
            }
            if (typeof event.no === 'function') {
                this.$data.onNo = event.no;
            }
        }
    },
};
</script>
<style>


</style>
